import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"help-ambient-bg",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"help-ambient-bg__scatter"},_vm._l((_vm.motes),function(mote,index){return _c(VIcon,{key:index,staticClass:"help-ambient-bg__mote",style:(_vm.moteStyle(mote)),attrs:{"size":mote.size}},[_vm._v(_vm._s(mote.icon))])}),1),_c('div',{staticClass:"help-ambient-bg__glow"}),_c('div',{staticClass:"help-ambient-bg__fade"})])
}
var staticRenderFns = []

export { render, staticRenderFns }